import { LegFlow } from 'models/LegFlow';
import { Valuation } from 'models/Valuation';
import { createAction, createAsyncAction } from 'typesafe-actions';

import { DebtLegTerms } from '../../../models/DebtLegTerms';

import { Transaction } from '../../RunDeliverable/store/types';

import { DebtInstrumentType } from '../enums';

import { FlowsState } from './components/FlowsReducer';
import { DebtLegState } from './components/LegsReducer';
import { TradeSummaryState } from './components/TradeSummaryReducer';

export type SetDebtInstrumentPayload = {
  debt_instrument_type_id: DebtInstrumentType;
};

export const setDebtInstrument = createAction(
  'debtPricer/setDebtInstrument',
)<SetDebtInstrumentPayload>();

export type GetTransactionByIdRequestPayload = {
  debt_id: Transaction['transaction_id'];
};
export type GetTransactionByIdSuccessPayload = {
  data: {
    debt_id: number;
    trade_summary: TradeSummaryState;
    leg: {
      leg_terms: DebtLegTerms;
      leg_flows: FlowsState;
    };
  };
};

export const getTransactionById = createAsyncAction(
  'debtPricer/getTransactionById/request',
  'debtPricer/getTransactionById/success',
  'debtPricer/getTransactionById/failure',
)<
  GetTransactionByIdRequestPayload,
  GetTransactionByIdSuccessPayload,
  undefined
>();

export type BuildSchedulePayloadRequest = {
  leg: DebtLegState;
  trade_summary: TradeSummaryState;
};
export type BuildSchedulePayloadSuccess = {
  flows: LegFlow[];
};

export const buildSchedule = createAsyncAction(
  'debtPricer/buildSchedule/request',
  'debtPricer/buildSchedule/success',
  'debtPricer/buildSchedule/failure',
)<BuildSchedulePayloadRequest, BuildSchedulePayloadSuccess, undefined>();

export type SaveTradePayloadRequest = {
  data: {
    curve_date: string;
    valuation_date: string;
    transaction: {
      debt_id: number | null;
      trade_summary: TradeSummaryState;
      leg: DebtLegState;
      update_trade?: boolean;
    };
  };
  stopNavigationToNewPage?: boolean;
};
export type SaveTradePayloadSuccess = {
  debt_id: number;
};

export const saveTrade = createAsyncAction(
  'debtPricer/saveTrade/request',
  'debtPricer/saveTrade/success',
  'debtPricer/saveTrade/failure',
)<SaveTradePayloadRequest, SaveTradePayloadSuccess, undefined>();

export const saveCopiedTrade = createAsyncAction(
  'debtPricer/saveCopiedTrade/request',
  'debtPricer/saveCopiedTrade/success',
  'debtPricer/saveCopiedTrade/failure',
)<SaveTradePayloadRequest, SaveTradePayloadSuccess, undefined>();

export type ValueTradePayloadRequest = {
  data: {
    curve_date: string;
    valuation_date: string;
    transaction: {
      debt_id: number | null;
      trade_summary: TradeSummaryState;
      leg: DebtLegState;
    };
  };
};
export type ValueTradePayloadSuccess = {
  data: {
    flows: LegFlow[];
    valuation: Valuation[];
  };
};
export const valueTrade = createAsyncAction(
  'debtPricer/valueTrade/request',
  'debtPricer/valueTrade/success',
  'debtPricer/valueTrade/failure',
)<ValueTradePayloadRequest, ValueTradePayloadSuccess, undefined>();

export type DeleteLegFlowsPayload = {
  legNumber: string | number;
};
export const deleteLegFlows = createAction(
  'debtPricer/deleteLegFlows',
)<DeleteLegFlowsPayload>();

export const resetAndChangeInstrumentType = createAction(
  'debtPricer/resetAndChangeInstrumentType',
)();

export const reset = createAction('debtPricer/reset')();
